import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { SkladonMappingType } from '../../types/skladonMapping';
import { useCheckPermission } from '../../utils/checkPermission';

export interface TopBlockPropsType {
    data: SkladonMappingType | null;
    idProvider: string | undefined;
    disableEdit: boolean;
    handleSave: () => void;
    activeTab: string;
    handleChangeTab: (value: string) => void;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    const canStatuses = useCheckPermission('INTEGRATION.MAPPING_STATUSES');
    const canShipping = useCheckPermission('INTEGRATION.MAPPING_SHIPPING_METHODS');
    const canPayments = useCheckPermission('INTEGRATION.MAPPING_PAYMENT_METHODS');
    const canOthers = useCheckPermission('INTEGRATION.MAPPING_OTHERS');
    const canAnyMappingSection = canStatuses || canShipping || canPayments || canOthers;

    const showSave = props.activeTab !== 'history';

    return (
        <BodyTopBlock
            tabs={[
                {
                    value: 'statuses',
                    label: translate('integrationDetail.statuses'),
                    hidden: !canStatuses
                },
                {
                    value: 'shippingMethods',
                    label: translate('integrationDetail.shippingMethods'),
                    hidden: !canShipping
                },
                {
                    value: 'paymentMethods',
                    label: translate('integrationDetail.paymentMethods'),
                    hidden: !canPayments
                },
                {
                    value: 'others',
                    label: translate('integrationDetail.others'),
                    hidden: !canOthers
                },
                {
                    value: 'history',
                    label: translate('integrationDetail.historyTab'),
                    hidden: !canAnyMappingSection
                }
            ]}
            selectTab={props.activeTab}
            onChangeTab={props.handleChangeTab}
            actions={
                showSave
                    ? [
                          {
                              label: translate('providerDetail.action.save'),
                              onClick: () => props.handleSave(),
                              disabled: props.disableEdit
                          }
                      ]
                    : []
            }
        />
    );
};

export default TopBlock;
